
import React from 'react'

import './Pane.sass'

// SessionPane is a horizontally-centered small window to be used for session-related tasks:
// - signing in
// - resetting the password
// - etc.
export const SessionPane = ({ children, className }) => (
  <div className='SessionPane'>
    <div className={className}>
      {children}
    </div>
  </div>
)

export const Pane = ({ children }) => <div className="Pane">
  <div className="Pane-inner">{children}</div>
</div>
